import { makeStyles } from '@material-ui/core/styles';

export const useStyles = makeStyles(() => ({
  loaderWrapper: {
    height: '100%',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },
}));
